<template>
  <div class="tw-mt-2">
    <div
      class="tw-fixed tw-top-0 tw-right-0 tw-h-screen tw-w-full md_tw-max-w-xl tw-bg-white tw-z-top tw-p-6 tw-transform tw-ease-in-out tw-transition-all tw-overflow-y-scroll tw-z-modal"
      :class="sidebarOpen ? 'tw-translate-x-0' : 'tw-translate-x-full'"
    >
      <div
        class="button-default tw-absolute tw-top-0 tw-right-0 tw-w-11 tw-h-11 tw-flex tw-justify-center tw-items-center tw-text-white"
        @click="sidebarOpen = false"
      >
        <stihl-icon
          name="cross"
          class="tw-w-4 tw-h-4"
        />
      </div>
      <div class="tw-flex tw-mt-4">
        <div
          class="tw-text-xl tw-p-4 tw-pl-0 tw-font-title"
          v-html="flyoutHeaderText"
        />
      </div>
      <div class="tw-py-5 tw-h-full tw-overflow-y-auto">
        <VariantListItem
          v-for="(item, index) in variants"
          :key="item.name + index"
          :variant="item"
          @variant-selected="selectedOption($event)"
        />
      </div>
    </div>
    <strong class="tw-font-medium tw-text-xs tw-font-sans tw-uppercase">Choose an Option</strong>
    <div>
      <div
        class="tw-relative tw-cursor-pointer tw-bg-white tw-w-full tw-flex tw-justify-between"
        @click="sidebarOpen = true"
        @mouseenter="isHover = true"
        @mouseleave="isHover = false"
      >
        <div
          class="tw-font-title tw-text-sm tw-pl-4 tw-py-5 tw-pr-8"
          v-html="selectedVariant.name"
        />
        <div
          class="button-default tw-w-8 tw-flex tw-items-center tw-justify-center tw-text-white"
          :class="{ 'button-default-active': isHover }"
        >
          <stihl-icon
            name="dropdown-down-arrow"
            class="-tw-rotate-90 tw-w-4 tw-h-4"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StihlIcon from './StihlIcon.vue';
import VariantListItem from "./VariantListItem.vue";

export default {
  components: {
    VariantListItem,
    StihlIcon
  },
  props: {
    variants: {
      type: Array,
      default: () => [],
    },
    selectedVariant: {
      type: Object,
      default: () => {},
    },
    categoryName: {
      type: String,
      default: "",
    },
    productName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isHover: false,
      sidebarOpen: false
    }
  },
  computed: {
    flyoutHeaderText() {
      return `${this.categoryName} / ${this.productName}`
    }
  },
  methods: {
    selectedOption(variant) {
      this.sidebarOpen = false;
      this.$emit("select-variant", variant);
    }
  }
}

</script>
